import { apiClient } from '@/lib/api-client';

export interface IgvMonthly {
  year: number;
  month: number;
  period: string;
  documentCount: number;
  byType: Record<string, { count: number; total: string }>;
  taxableTotal: string;
  exoneratedTotal: string;
  unaffectedTotal: string;
  igvTotal: string;
  grandTotal: string;
  voidedCount: number;
  pendingCount: number;
  rejectedCount: number;
  dueDate: string;
}

export interface PurchasesMonthly {
  period: string;
  purchaseCount: number;
  baseImponible: string;
  igvCredito: string;
  noGravado: string;
  total: string;
}

export interface IgvPosition {
  period: string;
  dueDate: string;
  igvVentas: string;
  igvCompras: string;
  resultado: string;
  aPagar: boolean;
  ventas: IgvMonthly;
  compras: PurchasesMonthly;
}

export async function getIgvMonthly(year: number, month: number): Promise<IgvMonthly> {
  const { data } = await apiClient.get<IgvMonthly>(`/reports/igv/${year}/${month}`);
  return data;
}

export async function getIgvPosition(year: number, month: number): Promise<IgvPosition> {
  const { data } = await apiClient.get<IgvPosition>(`/reports/igv-position/${year}/${month}`);
  return data;
}

async function downloadTxt(path: string, fallback: string): Promise<void> {
  const res = await apiClient.get<Blob>(path, { responseType: 'blob' });
  const filename = res.headers['content-disposition']?.match(/filename="([^"]+)"/)?.[1] ?? fallback;
  const url = URL.createObjectURL(res.data);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  URL.revokeObjectURL(url);
}

export function downloadPleSales(year: number, month: number): Promise<void> {
  return downloadTxt(`/reports/ple-sales/${year}/${month}`, `ple-ventas-${year}-${month}.txt`);
}

export function downloadPlePurchases(year: number, month: number): Promise<void> {
  return downloadTxt(`/reports/ple-purchases/${year}/${month}`, `ple-compras-${year}-${month}.txt`);
}
